<script>
  import { createEventDispatcher } from "svelte";

  export let visible = true;

  const dispatch = createEventDispatcher();

  const handleBegin = () => {
    visible = false;
    dispatch("close");
  };

  const handleKeydown = (event) => {
    if (visible && (event.key === "Enter" || event.key === "Escape")) {
      handleBegin();
    }
  };
</script>

<svelte:window on:keydown={handleKeydown} />

{#if visible}
  <div class="modal-overlay" on:click|self={handleBegin}>
    <div class="modal-container">
      <span class="eyebrow">GraspWell</span>

      <h1 class="title">The Irrational Map of Ethiopia</h1>

      <div class="body-text">
        <p>Nature drew Ethiopia's historical borders. Politcs drew today's borders.</p>
        <p>Compare the <strong class="imperial">1942-1974 Imperial Provincial Map</strong> vs. the <strong>1992-2026 Ethnic Federalist Map</strong> to see the shift from geography to ideology.</p>
      </div>

      <div class="instructions">
        <div class="instruction-item">
          <span class="instruction-icon">1</span>
          <span class="instruction-text">Toggle between Imperial and Ethnic borders using the map selector</span>
        </div>
        <div class="instruction-item">
          <span class="instruction-icon">2</span>
          <span class="instruction-text">Click anywhere on the map to trace river paths to the sea</span>
        </div>
      </div>

      <button class="begin-button" on:click={handleBegin}>
        [ BEGIN ANALYSIS ]
      </button>
    </div>
  </div>
{/if}

<style>
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    padding: 1rem;
  }

  .modal-container {
    background: rgba(10, 10, 10, 0.9);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: 16px;
    max-width: 540px;
    width: 100%;
    padding: 44px;
    box-shadow:
      0 25px 50px rgba(0, 0, 0, 0.5),
      0 0 0 1px rgba(255, 255, 255, 0.05) inset;
  }

  .eyebrow {
    display: block;
    font-size: 0.85rem;
    font-weight: 700;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    color: #D4AF37;
    margin-bottom: 1rem;
  }

  .title {
    font-size: 2.1rem;
    font-weight: 700;
    color: rgba(255, 255, 255, 0.95);
    line-height: 1.2;
    margin: 0 0 1.5rem 0;
    letter-spacing: -0.01em;
  }

  .body-text {
    margin-bottom: 1.75rem;
  }

  .body-text p {
    font-size: 1.1rem;
    line-height: 1.6;
    color: rgba(255, 255, 255, 0.6);
    margin: 0 0 1rem 0;
  }

  .body-text p:last-child {
    margin-bottom: 0;
  }

  .body-text strong {
    color: rgba(255, 255, 255, 0.9);
    font-weight: 600;
  }

  .body-text strong.imperial {
    color: #D4AF37;
  }

  .instructions {
    background: rgba(255, 255, 255, 0.03);
    border: 1px solid rgba(255, 255, 255, 0.06);
    border-radius: 10px;
    padding: 1.1rem 1.35rem;
    margin-bottom: 1.75rem;
  }

  .instruction-item {
    display: flex;
    align-items: flex-start;
    gap: 0.85rem;
    margin-bottom: 0.85rem;
  }

  .instruction-item:last-child {
    margin-bottom: 0;
  }

  .instruction-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.6rem;
    height: 1.6rem;
    background: rgba(79, 172, 254, 0.15);
    border: 1px solid rgba(79, 172, 254, 0.3);
    border-radius: 50%;
    font-size: 0.85rem;
    font-weight: 600;
    color: #4facfe;
    flex-shrink: 0;
  }

  .instruction-text {
    font-size: 1rem;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.5);
  }

  .begin-button {
    width: 100%;
    padding: 1.1rem 1.5rem;
    background: transparent;
    border: 1px solid rgba(255, 255, 255, 0.25);
    border-radius: 8px;
    color: rgba(255, 255, 255, 0.9);
    font-size: 1rem;
    font-weight: 600;
    letter-spacing: 0.15em;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  .begin-button:hover {
    background: rgba(255, 255, 255, 0.08);
    border-color: rgba(255, 255, 255, 0.4);
  }

  .begin-button:active {
    background: rgba(255, 255, 255, 0.12);
  }

  /* Mobile */
  @media only screen and (max-width: 600px) {
    .modal-container {
      padding: 30px 24px;
    }

    .eyebrow {
      font-size: 0.75rem;
    }

    .title {
      font-size: 1.65rem;
    }

    .body-text p {
      font-size: 1rem;
    }

    .instructions {
      padding: 0.95rem 1.1rem;
    }

    .instruction-text {
      font-size: 0.9rem;
    }

    .begin-button {
      font-size: 0.9rem;
    }
  }
</style>
